module.exports = __webpack_public_path__ + "static/Visual_Basic-5f1e4a7d0f568577ba21b849419248e3.svg";